import React from 'react';
import { Link } from 'react-router-dom';
import { instagramPosts } from '../data/mock';
import { Heart, Instagram } from 'lucide-react';

const InstagramSection = () => {
  return (
    <section className="py-20 bg-white overflow-hidden">
      <div className="max-w-7xl mx-auto px-6">
        {/* Heading */}
        <div className="text-center mb-12">
          <h2
            className="text-[#0a0a0a] font-black italic mb-3"
            style={{
              fontFamily: 'Nunito, sans-serif',
              fontSize: 'clamp(2rem, 5vw, 3.5rem)',
            }}
          >
            bucură-te de clipele bune
          </h2>
          <a
            href="https://www.instagram.com/drinkseltz/"
            target="_blank"
            rel="noopener noreferrer"
            className="text-[#0a0a0a] font-bold text-base hover:opacity-70 transition-opacity flex items-center gap-2 justify-center"
            style={{ fontFamily: 'Nunito, sans-serif' }}
          >
            <Instagram size={18} />
            @drinkseltz
          </a>
        </div>

        {/* Instagram Grid */}
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-3">
          {instagramPosts.map((post) => (
            <a
              key={post.id}
              href="https://www.instagram.com/drinkseltz/"
              target="_blank"
              rel="noopener noreferrer"
              className="group relative block aspect-square rounded-3xl overflow-hidden bg-white shadow-[0_4px_20px_rgba(0,0,0,0.05)] border border-gray-50"
            >
              <img
                src={post.image}
                alt={`Instagram post ${post.id}`}
                className="w-full h-full object-contain p-4 transition-transform duration-500 group-hover:scale-110"
                onError={(e) => {
                  e.target.src = `https://picsum.photos/300/300?random=${post.id + 20}`;
                }}
              />
              {/* Hover overlay with a brighter look */}
              <div className="absolute inset-0 bg-white/40 backdrop-blur-[2px] opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex flex-col items-center justify-center gap-2">
                <Heart size={20} className="text-[#0a0a0a] fill-[#0a0a0a]" />
                <span className="text-[#0a0a0a] font-bold text-sm" style={{ fontFamily: 'Nunito, sans-serif' }}>
                  {post.likes.toLocaleString()}
                </span>
              </div>
            </a>
          ))}
        </div>

        {/* Follow button */}
        <div className="text-center mt-10">
          <a
            href="https://www.instagram.com/drinkseltz/"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-2 bg-[#0a0a0a] text-white font-black italic text-sm px-8 py-3 rounded-full hover:bg-[#222222] transition-all duration-200 hover:scale-105"
            style={{ fontFamily: 'Nunito, sans-serif' }}
          >
            <Instagram size={16} />
            urmărește-ne
          </a>
        </div>
      </div>
    </section>
  );
};

export default InstagramSection;
